import React from 'react';
import { PrimaryHeader } from 'Components/Display';

export const ConfigurationHeader: React.FC = () => {
  return <PrimaryHeader title="Configuration" />;
};
